module.exports = __webpack_public_path__ + "static/media/antigua-historic-23.443a96f7.jpg";